module.exports = __webpack_public_path__ + "static/img/4.229431a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/sp/4.png
// module id = u2zX
// module chunks = 0